/**
 * Overlays the live collab field values onto the REST-fetched content doc,
 * cloning only along the written paths (the doc can be large — annotations
 * etc. — so a deep clone per remote keystroke is off the table). Everything
 * not in `fields` keeps referencing the original objects, which also keeps
 * ViewBlockGenerator's memo comparisons cheap.
 */
export const mergeCollabFieldsIntoContent = ({ content, fields }) => {
  if (!content || !fields) return content;

  const merged = { ...content };
  Object.entries(fields).forEach(([path, value]) => {
    const segments = path.split(".");
    let dst = merged;
    for (let i = 0; i < segments.length - 1; i++) {
      // spread dst (not content) so multiple paths under the same parent
      // don't clobber each other's writes
      dst[segments[i]] = { ...(dst[segments[i]] || {}) };
      dst = dst[segments[i]];
    }
    dst[segments[segments.length - 1]] = value;
  });
  return merged;
};
